import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getSubCustomers = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/subcustomer-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createSubCustomers = (data, token) =>
  axios.post(`${baseUrl}/subcustomer`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteSubCustomers = (id, token) =>
  axios.delete(`${baseUrl}/subcustomer/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateSubCustomers = (id, data, token) =>
  axios.patch(`${baseUrl}/subcustomer/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getSubCustomersById = (id, token) =>
  axios.get(`${baseUrl}/subcustomer/${id}`, {
    headers: {
      authorization: token,
    },
  });
